import { IconSize } from "@blueprintjs/core";
import { Spinner, Icon, InfoTooltip } from "@goodfill/ui-components";
import { BatchOrderLineLifecycleStatus } from "./BatchOrderLineState";

export const BatchOrderLineStatusIndicator = ({ status }: { status: BatchOrderLineLifecycleStatus }) => {
  return {
    prepare: <Icon name="empty" size={IconSize.LARGE} />,
    loading: <Spinner size={IconSize.LARGE} />,
    done: <Icon name="circle-checked" color="green" size={IconSize.LARGE} />,
    failed: <InfoTooltip text={""} intent="danger" size={IconSize.LARGE} />,
  }[status];
};
